<template>
  <v-dialog
    v-model="computedLiftmaintenanceLifttowerVisibility"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card tile>
      <v-toolbar card>
        <!-- close icon -->
        <v-btn
          icon
          @click="
            methodToggleSingleLayer('liftmaintenance', 'lifttowers', false)
          "
        >
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>
          <span class="hidden-sm-and-down">{{ computedLiftName }}</span>
          <span>#{{ computedTowerNum }}</span>
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <!-- forward/back buttons -->
        <!-- forward buttons -->
        <v-tooltip bottom>
          <!-- previous tower button enabled -->
          <v-btn
            v-if="computedPreviousTower"
            icon
            slot="activator"
            @click="
              methodToggleSingleLayer(
                'liftmaintenance',
                'lifttowers',
                'true',
                computedPreviousTower
              )
            "
          >
            <v-icon>chevron_left</v-icon>
          </v-btn>
          <!-- next tower button disabled -->
          <v-btn v-if="!computedPreviousTower" disabled icon slot="activator">
            <v-icon>chevron_left</v-icon>
          </v-btn>
          <span>Previous tower</span>
        </v-tooltip>
        {{ computedLiftName }}
        <!-- forward button -->
        <v-tooltip bottom>
          <!-- next tower button enabled -->
          <v-btn
            v-if="computedNextTower"
            icon
            slot="activator"
            @click="
              methodToggleSingleLayer(
                'liftmaintenance',
                'lifttowers',
                'true',
                computedNextTower
              )
            "
          >
            <v-icon>chevron_right</v-icon>
          </v-btn>
          <!-- next tower button disabled -->
          <v-btn v-if="!computedNextTower" disabled icon slot="activator">
            <v-icon>chevron_right</v-icon>
          </v-btn>
          <span>Next tower</span>
        </v-tooltip>
      </v-toolbar>
      <div
        style="background-color: black; padding-left: 30px; overflow:auto; -webkit-overflow-scrolling:touch;"
      >
        <v-data-table
          :items="computedLiftmaintenanceLifttowerGeoJsonFeature"
          :loading="computedLiftmaintenanceLifttowersLoading"
          :hide-actions="hideactions"
          :hide-headers="hideheaders"
        >
          <template slot="items" slot-scope="props">
            <tr>
              <td>Mountain</td>
              <td>{{ props.item.properties.mountain }}</td>
            </tr>
            <tr>
              <td>Lift Name</td>
              <td>{{ props.item.properties.lift_name }}</td>
            </tr>
            <tr>
              <td>Tower #</td>
              <td>{{ props.item.properties.twr_num }}</td>
            </tr>
            <tr>
              <td>Tube Length (m)</td>
              <td>{{ props.item.properties.tube_length }}</td>
            </tr>
            <tr>
              <td>Tube Length (mm)</td>
              <td>{{ props.item.properties.tube_length_mm }}</td>
            </tr>
            <tr>
              <td>Tube Angle</td>
              <td>{{ props.item.properties.tube_angle }}</td>
            </tr>
            <tr>
              <td>Tube Inclination (%)</td>
              <td>{{ props.item.properties.tube_inclination_perc }}</td>
            </tr>
            <tr>
              <td>Sheaves Up</td>
              <td>{{ props.item.properties.sheaves_up }}</td>
            </tr>
            <tr>
              <td>Sheaves Down</td>
              <td>{{ props.item.properties.sheaves_down }}</td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <div style="flex: 1 1 auto;"></div>
    </v-card>
  </v-dialog>
</template>

<style scoped>
table {
  padding-top: 20px;
}
</style>
<script>
export default {
  data() {
    return {
      loading: true,
      persistent: false,
      hideheaders: true,
      hideactions: true,
      solo: true
    };
  },
  computed: {
    computedSameLift() {
      // returns an alphabetically sorted list of hydrnt_nums and ids of hyds on the same run as current hyd
      if (this.computedLiftmaintenanceLifttowerVisibility) {
        let lift = this.$store.state.mapLayers.liftmaintenance.layers.lifttowers
          .geojson.features;
        // Gets all entries that are the same lift as the currently viewed ID
        let result = lift.filter(
          item => item.properties.lift_name == this.computedLiftName
        );
        // Constructs JSON obj of twr_num: id key value pairs
        let o = [{}];
        for (let i = 0; i < result.length; i++) {
          o[i] = {};
          o[i].twr_num = result[i].properties.twr_num;
          o[i].id = result[i].properties.id;
        }
        // sorts constructed json by twr_num alphabetically
        let sortedTwr_num = o.sort((a, b) => {
          a = a.twr_num;
          b = b.twr_num;

          return a < b ? -1 : a > b ? 1 : 0;
        });
        return sortedTwr_num;
      }
      return [];
    },
    computedNextTower() {
      if (this.computedLiftmaintenanceLifttowerVisibility) {
        // define the array
        let arr = [];
        // loop through tower on the same lift
        for (let i = 0; i < this.computedSameLift.length; i++) {
          // push hydrants that are next to the array
          if (this.computedTowerNum < this.computedSameLift[i].twr_num) {
            arr.push(this.computedSameLift[i].id);
          }
        }
        // return the next tower only
        if (typeof arr[0] !== "undefined") {
          return arr[0];
        } else {
          return false;
        }
      }
      return [];
    },
    computedPreviousTower() {
      if (this.computedLiftmaintenanceLifttowerVisibility) {
        // define the array
        let arr = [];
        // loop through towers on the same lift
        for (let i = 0; i < this.computedSameLift.length; i++) {
          // push towers that are next to the array
          if (this.computedTowerNum > this.computedSameLift[i].twr_num) {
            arr.push(this.computedSameLift[i].id);
          }
        }

        let arrrev = arr.reverse();
        // return the next tower only
        if (typeof arrrev[0] !== "undefined") {
          return arrrev[0];
        } else {
          return false;
        }
      }
      return [];
    },
    computedLiftName() {
      if (this.computedLiftmaintenanceLifttowerVisibility) {
        const lifttowers = this.$store.state.mapLayers.liftmaintenance.layers
          .lifttowers.geojson.features;
        // grabs the lift_name of the currently viewed ID
        let result = lifttowers.filter(
          item => item.properties.id == this.computedLiftmaintenanceLifttowerId
        );
        return result[0].properties.lift_name;
      }
      return [];
    },
    computedTowerNum() {
      if (this.computedLiftmaintenanceLifttowerVisibility) {
        const lifttowers = this.$store.state.mapLayers.liftmaintenance.layers
          .lifttowers.geojson.features;
        // grabs the lift_name of the currently viewed ID
        let result = lifttowers.filter(
          item => item.properties.id == this.computedLiftmaintenanceLifttowerId
        );
        return result[0].properties.twr_num;
      }
      return [];
    },
    computedLiftmaintenanceLifttowerGeoJsonFeature() {
      if (
        this.$store.state.mapLayers.liftmaintenance.layers.lifttowers.geojson
          .features
      ) {
        const lifttowers = this.$store.state.mapLayers.liftmaintenance.layers
          .lifttowers.geojson.features;
        const result = lifttowers.filter(
          item => item.properties.id == this.computedLiftmaintenanceLifttowerId
        );
        return result;
      }
      return [];
    },
    computedLiftmaintenanceLifttowerVisibility() {
      return this.$store.state.mapLayers.liftmaintenance.layers.lifttowers
        .visibility.singleView;
    },
    computedLiftmaintenanceLifttowersLoading() {
      return this.$store.state.mapLayers.liftmaintenance.layers.lifttowers
        .loading;
    },
    computedLiftmaintenanceLifttowerId() {
      return this.$store.state.mapLayers.liftmaintenance.layers.lifttowers
        .visibility.singleId;
    },
    computedAuth() {
      return this.$store.state.auth;
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    }
  },
  methods: {
    // method to get geojson
    methodGetLiftmaintenanceLifttowerGeoJson() {
      this.$store.dispatch("actionGetGeoJson", {
        url:
          "https://api2.alchemymapping.com/vail/whistler/liftmaintenance/lifttowers",
        dept: "liftmaintenance",
        layer: "lifttowers",
        token: this.computedAuthToken
      });
    }
  },
  watch: {
    // watches the visibility of the list view, and if visible, calls action to get geojson.
    "$store.state.mapLayers.liftmaintenance.layers.lifttowers.visibility.singleView": function(
      newValue
    ) {
      if (newValue) {
        this.methodGetLiftmaintenanceLifttowerGeoJson();
      }
    },
    // after data is loaded, set loading = false to stop loading progress indicator
    "$store.state.mapLayers.liftmaintenance.layers.lifttowers.geojson": function(
      newValue
    ) {
      if (newValue) {
        this.loading = false;
      }
    }
  }
};
</script>
